import axios from "axios";
import config from "../config.js";

const BASE_URL_API = config.API_SERVICE_URL;

export const getPdfStatus = async (code) => {
  return axios.get(`${BASE_URL_API}/pdf/status/${code}`);
};
